import { render, staticRenderFns } from "./UpInstructions.vue?vue&type=template&id=6df63b90&"
import script from "./UpInstructions.vue?vue&type=script&lang=js&"
export * from "./UpInstructions.vue?vue&type=script&lang=js&"
import style0 from "./UpInstructions.vue?vue&type=style&index=0&id=6df63b90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports